<div class="container mtop5">
    <div class="text-center">
        <div class="">
            <i class="material-icons biggerIcon">not_interested</i>
        </div>
    </div>
    <div class="text-center">
        <div>
            <h3>{{'USER.WARNING_MESSAGES.NO_PERMISSIONS' | translate}}</h3>
            {{'USER.WARNING_MESSAGES.NO_PERMISSIONS_2' | translate}}
        </div>
    </div>
</div>